module.exports = __webpack_public_path__ + "02_glasses_black.c341934a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer4/02_glasses_black.png
// module id = CV0v
// module chunks = 0